<template>
  <div class="diagnosis-main">
    <title-screen title="5"></title-screen>
    <div class="diagnosis-question">
        <p class="mb-4">
            相続人が複数いた場合、遺産の分割をめぐってモメてしまうことがしばしばあります。モメて得なことは基本的にないため、少しでも未然に防ぐことが重要です。まずは現状把握のために下記診断を行い、対応策をお読みいただければと思います。
            <br/>会員登録されれば判定結果を保存しておくこともできます。
            <br/>相続が発生した場合も、相続発生前の場合も、どちらの局面でもご利用できます。
        </p>
        <p>
          ５問と２０問の設問が用意されています。下のボタンよりどちらかを選択して診断を行ってください。<br/>
          設問の表現では、相続が発生したケースを前提とした用語になっていますが、相続が発生する前の場合では読み替えて頂きたく思います（たとえば「被相続人」は「財産所有者」、「相続人」は「推定相続人」など）　。
          また、判定結果の「モメ度数」は相続専門の税理士法人レガシィに所属する税理士等の専門家約70名からのヒアリングをもとに統計的に算出しております。
        </p>
      <div class="mt-20 mb-3" style="text-align: center">
          <div style="display: flex; flex-flow: row wrap; justify-content: center">
              <div style="padding: 5px">
                  <el-button class="btn button-color btn-number-question gtm_mome_short" @click="loadQuestion(5)">
                      <p class="gtm_mome_short btn-number-question__1">5問</p>
                      <p class="gtm_mome_short btn-number-question__2">時間がない方は</p>
                      <p class="gtm_mome_short btn-number-question__3">こちら</p>
                  </el-button>
              </div>
              <div style="padding: 5px">
                  <el-button class="btn button-color btn-number-question gtm_mome_long" @click="loadQuestion(20)">
                      <p class="gtm_mome_long btn-number-question__1">20問</p>
                      <p class="gtm_mome_long btn-number-question__2">詳細に診断したい方は</p>
                      <p class="gtm_mome_long btn-number-question__3">こちら</p>
                  </el-button>
              </div>
          </div>
      </div>
        <p class="mb-2">設問の表現では、相続が発生したケースを前提とした用語になっていますが、相続が発生する前の場合では読み替えて頂きたく思います（たとえば「被相続人」は「財産所有者」、「相続人」は「推定相続人」など）</p>
        <div class="el-table no-border">
        <table class="el-table__row--hover el-table__row--padding table" style="width: 100%">
          <thead>
            <th width="42">番号</th>
            <th>設問</th>
            <th class="w-20p">回答</th>
          </thead>
          <tbody>
          <tr v-for="(dq, dqIndex) in disputeQuestions" :key="dq.id">
            <td>{{ convertNumberFont(dqIndex + 1) }}</td>
            <td style="text-align: left !important; max-width: 500px">
                <div v-html="dq.question"></div>
            </td>
            <td class="min-width-unset text-align-unset" style="min-width: 200px">
              <div class="d-inline-block mr-3">
                <el-radio v-model="answer[dq.id]" :label="true">はい</el-radio>
              </div>
              <div class="d-inline-block">
                <el-radio class="mt-2 mt-sm-0" v-model="answer[dq.id]" :label="false">いいえ</el-radio>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
        <div style="text-align: center" v-show="isMobile">
            <br>
            <h1 style="color:#a5272a">すべて回答したら</h1>
            <h1 style="color:#a5272a">ボタンを押してください</h1>
        </div>
      <div class="btn-diagnosis">
          <el-popover
              v-if="!isAllQuestionChecked"
              placement="top"
              width="200"
              trigger="hover"
              content="回答を入力してからボタンを押してください。">
              <el-button class="btn button-color cursor-not-allowed" slot="reference">診断を行う</el-button>
          </el-popover>
          <el-button v-else class="btn button-color gtm_mome_diagnosis" :disabled="isDisableBtnDiagnosis" @click="showAnswer"><span class="gtm_mome_diagnosis">診断を行う</span></el-button>
      </div>
    </div>
    <div class="diagnosis-result" v-if="isShowDiagnosisResult">
      <div class="text-center">
        <p class="dr-title">診断結果</p>
        <p class="fs-20">あなたの<span class="color-red--tuna">モメ度</span>は <span class="dr-title color-red--tuna">{{diagnosisAnswer.answer}} </span>です</p>
        <p class="fs-20">{{diagnosisAnswer.message}}</p>
      </div>
      <div class="mt-4">
          <p class="mb-3">
              <span class="color-red--tuna">モメ度</span>とは<br>
              回答結果を基に、AからEの5段階であなたの相続がモメる可能性を判定しています。Aは最もモメる可能性が高いこと、Eはモメる可能性が低いことを示しています。
          </p>
          <p class="mb-4">
              <span class="color-red--tuna">モメ度数</span>とは<br>
              相続専門税理士など専門家70人へのアンケートやヒアリング等により、また相続事案における経験を加味し、数値化したものです。各設問ごとに、その内容に該当した場合、どの程度モメることにつながりやすいかを表しています。高いほど、モメる要因となりうることを示しています。
          </p>
        <p class="font-weight-bold">あなたが<span class="color-red--tuna">はい</span>と回答したモメる要因となる事項</p>
          <p v-if="numberQuestion === 5 && listQuestionTrueView.length === 0" class="font-weight-bold">
              <br/>
              表示される事項はございません。
              <br/>
              より詳細に診断が行える20問版をご利用ください。
          </p>
          <p v-if="numberQuestion === 20 && listQuestionTrueView.length === 0" class="font-weight-bold">
              <br/>
              表示される事項はございません。
              <br/>
              すべてに該当しないのであればモメる可能性は低いでしょう。
          </p>
          <div class="table-responsive">
              <table class="table-custom-el table-answer">
                  <tr v-for="question in listQuestionTrueView" :key="question.key + question.id"
                      v-bind:class="[question.key === 'categoryDetail' ? 'tbl-last-tr' : 'tbl-tr']">
                      <td style="min-width: 140px">
                          <template v-if="question.key === 'frequency'">
                              <div class="d-inline-block font-weight-bold color-red--tuna">{{question.title}}</div>
                          </template>
                          <template v-else>{{question.title}}</template>
                      </td>
                      <td style="min-width: 400px">
                          <div v-html="question.content"></div>
                      </td>
                  </tr>
              </table>
          </div>
      </div>
    </div>
    <div class="btn-contact">
        <el-button class="el-button-big gtm_mome_inquiry_mome" @click="redirectContact"><span class="gtm_mome_inquiry_mome">詳しくご相談されたい方はこちら</span></el-button>
    </div>
    <member-note :type="noteType" :gtm_class="gtmClass" v-if="isAuthenticated"></member-note>
  </div>
</template>

<script>
    import DiagnosisApi from '@/api/diagnosis'
    import { mapGetters } from 'vuex'
    import { isMobile } from 'mobile-device-detect'
    import TitleScreen from '@/components/common/TitleScreen'
    import MemberNote from '@/components/common/MemberNote'
    import { NOTE_TYPE } from '../../../../common/constance'

    export default {
        name: 'diagnosis',
        components: {
            'title-screen': TitleScreen,
            'member-note': MemberNote
        },
        data () {
            return {
                disputeQuestions: [],
                listQuestionTrueView: [],
                diagnosisAnswer: {},
                disputeAnswers: [],
                answer: {},
                isDisableBtnDiagnosis: true,
                isAllQuestionChecked: false,
                isShowDiagnosisResult: false,
                noteType: NOTE_TYPE.DISPUTE_ANS,
                numberQuestion: null,
                isMobile: isMobile,
                gtmClass: 'gtm_mome_memo_mome'
            }
        },
        methods: {
            async loadQuestion (numberQuestion) {
                try {
                    this.isShowDiagnosisResult = false
                    this.isDisableBtnDiagnosis = true

                    if (!this.isAuthenticated) {
                        return this.getQuestionByQuestionNumber(numberQuestion || 5)
                    }
                    return this.loadDisputeQuestion(numberQuestion)
                } finally {
                    this.isDisableBtnDiagnosis = false
                }
            },
            async loadDisputeQuestion (defaultQuestionNumber) {
                const response = await DiagnosisApi.loadDisputeQuestion(defaultQuestionNumber)
                const data = response.data

                const { numberQuestion, disputeQuestionResponseDTOS, diagnosisAnswerDTO, disputeAnswers } = data

                this.numberQuestion = numberQuestion
                this.disputeQuestions = disputeQuestionResponseDTOS
                this.diagnosisAnswer = diagnosisAnswerDTO || {}
                this.disputeAnswers = disputeAnswers || []
                if (!!diagnosisAnswerDTO && !!disputeAnswers) {
                    this.updateAnswer()
                } else {
                    this.answer = {}
                }
            },
            async getQuestionByQuestionNumber (numberQuestion) {
                const response = await DiagnosisApi.getQuestionByQuestionNumber(numberQuestion)
                const questions = response.data

                this.numberQuestion = numberQuestion
                this.disputeQuestions = questions
                this.answer = {}
            },
            async showAnswer () {
                try {
                    this.isDisableBtnDiagnosis = true

                    await this.createOrUpdateDisputeAns()
                    await this.getDiagnosisAnswer()
                } finally {
                    this.isDisableBtnDiagnosis = false
                }
            },
            async createOrUpdateDisputeAns () {
                if (this.isAuthenticated) {
                    const numberQuestion = this.numberQuestion
                    const disputeAnswerDTOs = Object.keys(this.answer).map(questionId => {
                        const existsAnswer = this.disputeAnswers.find(d => +d.disputeQuestionId === +questionId)
                        return {
                            id: existsAnswer ? existsAnswer.id : null,
                            disputeQuestionId: questionId,
                            isChecked: this.answer[questionId]
                        }
                    })

                    const res = await DiagnosisApi.createOrUpdateDisputeAns({
                        numberQuestion,
                        disputeAnswerDTOs
                    })

                    this.disputeAnswers = res.data
                }
            },
            async getDiagnosisAnswer () {
                const questionCheckedIds = []
                Object.keys(this.answer).forEach(questionId => {
                    if (this.answer[questionId]) {
                        questionCheckedIds.push(questionId)
                    }
                })

                const diagnosisAnswerRes = await DiagnosisApi.getDiagnosisAnswer(questionCheckedIds)

                this.diagnosisAnswer = diagnosisAnswerRes.data
                this.updateListQuestionTrueView()
            },
            updateAnswer () {
                const answer = {}
                this.disputeAnswers.forEach(d => {
                    if (this.disputeQuestions.some(dq => +dq.id === +d.disputeQuestionId)) {
                        answer[d.disputeQuestionId] = d.isChecked
                    }
                })

                this.answer = answer
                this.updateListQuestionTrueView()
            },
            updateListQuestionTrueView () {
                this.listQuestionTrueView = []

                for (let index = 0; index < this.disputeQuestions.length; index++) {
                    const questionTrue = this.disputeQuestions[index]
                    if (!this.answer[questionTrue.id]) {
                        continue
                    }

                    const disputeKnowHowDTOS = questionTrue.disputeKnowHowDTOS || []
                    const disputeKnowHowDTOSLink = disputeKnowHowDTOS.map(d => {
                        // eslint-disable-next-line no-template-curly-in-string
                        return `<a class="word-break-all link-color gtm_mome_yonde_mome" target="_blank" href="/categoryDetail/${d.id}?previousPage=diagnosis">${d.name}</a>`
                    }).join('<br/>')

                    this.listQuestionTrueView.push(...[
                        {
                            id: questionTrue.id,
                            key: 'question',
                            title: '設問' + this.convertNumberFont(index + 1),
                            content: questionTrue.question
                        },
                        {
                            id: questionTrue.id,
                            key: 'frequency',
                            title: 'モメ度数',
                            content: `<div class="font-weight-bold color-red--tuna">${questionTrue.frequency.toFixed(1) + '%'}</div>`
                        },
                        {
                            id: questionTrue.id,
                            key: 'comment1',
                            title: 'モメる理由',
                            content: questionTrue.comment1
                        },
                        {
                            id: questionTrue.id,
                            key: 'comment2',
                            title: '対策案',
                            content: questionTrue.comment2
                        },
                        {
                            id: questionTrue.id,
                            key: 'categoryDetail',
                            title: '関連する読み物',
                            content: disputeKnowHowDTOSLink
                        }
                    ])
                }

                this.isShowDiagnosisResult = true
            },
            checkEnableBtnDiagnosis () {
                let allAnswersChecked = true
                for (const question of this.disputeQuestions) {
                    if (!this.answer.hasOwnProperty(question.id)) {
                        allAnswersChecked = false
                        break
                    }
                }
                this.isAllQuestionChecked = allAnswersChecked
            },
            convertNumberFont (num) {
                const numTexts = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩', '⑪', '⑫', '⑬', '⑭', '⑮', '⑯', '⑰', '⑱', '⑲', '⑳']
                return numTexts[num - 1]
            },
            redirectContact () {
                let routeData = this.$router.resolve({ name: 'contact' })
                window.open(routeData.href, '_blank')
            }
        },
        watch: {
            'answer': {
                deep: true,
                handler () {
                    this.checkEnableBtnDiagnosis()
                }
            }
        },
        computed: {
            ...mapGetters(['isAuthenticated'])
        },
        created () {
            this.loadQuestion()
            window.scroll(0, 0)
        }
    }
</script>

<style scoped>
  @import "../../../../assets/css/custom.css";
  .diagnosis-main {
    margin-bottom: 30px;
  }

  .diagnosis-main p {
      font-size: 16px;
  }
  .diagnosis-question table th,
  .diagnosis-question table td,
  .diagnosis-result table th,
  .diagnosis-result table td {
      font-size: 16px!important;
  }

  .btn-diagnosis {
    text-align: center;
    margin-top: 20px;
  }

  .btn-contact {
      text-align: center;
      margin-top: 40px;
  }

  .dr-title {
    font-size: 24px !important;
  }

  .diagnosis-result {
    margin-top: 50px;
  }

  .mt-10 {
    margin-top: 10px !important;
    font-size: 14px !important;
  }

  .mt-20 {
    margin-top: 20px !important;
  }

  .table-custom-el {
    width: 100%;
    color: #000000;
  }

  .table-custom-el tr {
    background-color: #FFF;
  }

  .table-custom-el td {
    padding: 12px 10px;
  }

  .table-custom-el tr.tbl-last-tr {
    border-bottom: 2px solid #000000;
  }

  .table-custom-el tr.tbl-tr {
      background: radial-gradient(circle at bottom, black 1px, transparent 1.5px) repeat-x bottom;
      background-size: 5px 4px;
  }

  table.table-answer {
      margin-top: 15px;
      border-top: 2px solid #000000;
  }
  table.table-answer .question-id {
      width: 80px;
  }
  table.table-answer .question-content {
      min-width: 300px;
  }
  table.table-answer .question-link {
      width: 200px;
  }

  @media screen and (max-width: 1223px){
    .min-width-unset{
      min-width: unset !important;
    }
  }

  @media screen and (max-width: 698px){
    .text-align-unset{
      text-align: unset !important;
    }
  }
  .w-20p {
    width: 20%;
  }
  .no-border {
      border: unset !important;
      border-radius: unset !important;
  }
  _:-ms-lang(x)::-ms-backdrop, .no-border {
      border: none !important;
      border-radius: none !important;
  }
  _:-ms-lang(x)::-ms-backdrop, .no-border .table {
      border-collapse: separate;
  }
  .table thead th {
      border-bottom: 5px solid #ff9900;
  }
  .table thead th + th{
      border-left: 1px solid #d6d6d6 !important;
  }
  .table th {
      background-color: #fffaf0 !important;
  }
  .table tr {
      background-color: #fffafa !important;
  }
  .table td {
      background-color: #fffafa !important;
  }
  .table tbody td + td {
      border-left: 1px solid #d6d6d6 !important;
  }
  .table thead + tbody td {
      border-top: 1px solid #d6d6d6 !important;
  }
  .btn-contact button {
      line-height: normal;
  }
</style>
